import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { DOCUMENT_META_DATA_ACTION_TYPE } from "./document-meta.action";
import { DocumentMetaState } from "./document-meta.model";

const INITIAL_STATE: DocumentMetaState = {};

export function documentMetaReducer(state = INITIAL_STATE, action: ActionWithPayload): DocumentMetaState {
	switch (action.type) {
		case DOCUMENT_META_DATA_ACTION_TYPE.set: {
			return updateState(state, action.payload);
		}
		case DOCUMENT_META_DATA_ACTION_TYPE.updateMetaTitle: {
			return updateState(state, {
				metaTitle: action.payload,
			});
		}
		default:
			return state;
	}
}
